import { useState } from "react";
import { CalendarPlus, Check } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { track } from "@/lib/track";

export function QuickAddToTrip({ item }) {
  const [state, setState] = useState("idle");
  const add = async () => {
    setState("busy");
    try {
      const day = new Date().toLocaleDateString("en-CA");
      await api.post("/itinerary", { city: item.city || "", day, time: "", start_at: null, listing: item });
      track(item, "trip_add");
      toast.success(`Added ${item.name} to today's trip`);
      setState("done");
    } catch (e) { toast.error(errorMessage(e)); setState("idle"); }
  };
  const done = state === "done";
  return (
    <button type="button" data-testid={`quick-add-trip-${item.id}`} disabled={state !== "idle"} onClick={add}
      className={`mt-2 w-full h-10 rounded-full text-sm font-semibold flex items-center justify-center gap-1.5 transition-[background-color,transform] active:scale-95 ${done ? "bg-[#00E5A3]/15 text-[#00E5A3]" : "bg-[#00E5A3] text-[#0B0F19] hover:bg-[#00C98F]"}`}>
      {done ? <><Check className="h-4 w-4" /> In today's trip</> : <><CalendarPlus className="h-4 w-4" /> {state === "busy" ? "Adding…" : "Add to today's trip"}</>}
    </button>
  );
}
